import type { UserRole } from '../stores/auth-store';

interface JwtPayload {
  sub?: string;
  accountId?: string | null;
  orgId?: string | null;
  role?: UserRole;
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const parsed = JSON.parse(window.atob(normalized));
    return parsed as JwtPayload;
  } catch {
    return null;
  }
}
